// src/routes/AppRoutes.jsx
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { isAuthenticated } from './utils/authUtils';
import Login from '../components/Auth/Login/Login';
import ForgotPassword from '../components/Auth/Login/ForgetPassword';
import CheckEmail from '../components/Auth/Login/CheckEmail';
import SetNewPassword from '../components/Auth/Login/SetNewPassword';
import PasswordReset from '../components/Auth/Login/PasswordReset';
import AdminLayout from '../components/toolManagment/Admin';
import { AdminPortalRoutes } from '../components/toolManagment/Admin/routes/Routes';
import NCodes from '../components/tools/nCodes/nCodes';
import InnerDrive from '../components/tools/innerDrive/InnerDrive';
import PersonalityTest from '../components/tools/PersonalityTest/personalityTest';
import InnerNeeds from '../components/tools/innerNeeds&TraitTest/innerNeeds&TraitTest';
import BaseLine from '../components/tools/BaseLine/baseLine';
import Unauthorized from './Unauthorized';
import Comp_404 from '../common/404';
import LoginFormFORprospect from '../components/tools/LoginFormFORprospect';
import FeedbackForm from '../components/LearningFeedback/FeedbackForm';

const ProtectedAdminLayout = () => {
  const isAuth = isAuthenticated();
  if (!isAuth) {
    console.log("No auth token - redirecting to login");
    return <Navigate to="/login" replace />;
  }

  return <AdminLayout />;
};

const PublicRoute = ({ element }) => {
  const isAuth = isAuthenticated();
  
  if (isAuth) {
    console.log("User already authenticated - redirecting to dashboard");
    // Redirect to your default authenticated page (adjust the path as needed)
    return <Navigate to="/setting" replace />;
  }
  
  return element;
};

const AppRoutes = () => {
  return (
    <Routes>
      {/* Public routes - If authenticated, redirect to dashboard */}
      <Route path="/login" element={<PublicRoute element={<Login />} />} />
      <Route path="/forgot-password" element={<PublicRoute element={<ForgotPassword />} />} />
      <Route path="/check-email" element={<PublicRoute element={<CheckEmail />} />} />
      <Route path="/reset-password" element={<PublicRoute element={<SetNewPassword />} />} />
      <Route path="/password-reset" element={<PublicRoute element={<PasswordReset />} />} />
      <Route path="/unauthorized" element={<Unauthorized />} />
      
      {/* Tool routes - add protection if needed */}
      <Route path="/tool/:id" element={<NCodes />} />
      <Route path="/Inner_Drive" element={<InnerDrive />} />
      <Route path="/Personality_Test" element={<PersonalityTest />} />
      <Route path="/Inner_Needs" element={<InnerNeeds />} />
      <Route path="/traits-test" element={<InnerNeeds />} />
      <Route path="/baselines" element={<BaseLine />} />
      <Route path="/pros" element={<LoginFormFORprospect />} />
      <Route path="/feedback" element={<FeedbackForm />} />
      {/* ALL other routes require authentication */}


      <Route path="/*" element={<ProtectedAdminLayout />}>
        <Route path="*" element={<AdminPortalRoutes />} />
      </Route>

      {/* Fallback for any route not matched above, including when not logged in */}
      <Route path="*" element={<Comp_404 />} />

      {/* Fallback for root path */}
      <Route 
        path="/" 
        element={
          isAuthenticated() ? 
          <Navigate to="/dashboard" replace /> : 
          <Navigate to="/login" replace />
        } 
      />
    </Routes>
  );
};

export default AppRoutes;